import { External } from "@bcc-ui/ui-components";
import { t } from "i18next";
import React from "react";

import { NavigationSubMenuItem } from "./navigation-sub-menu-item/NavigationSubMenuItem";
import { useIsChildRouteEnabled } from "components/navigation/hooks/useIsChildRouteEnabled";
import { useIsRouteEnabled } from "components/navigation/hooks/useIsRouteEnabled";
import { KNOWLEDGE_BASE_ROUTE, RouteDefinition } from "components/router/Routes";

import testIds from "testIds.json";

interface Props {
    mainRoute: RouteDefinition;
}

export const ProductsSubmenu = (props: Props) => {
    const isRouteEnabled = useIsRouteEnabled();
    const { isChildRouteEnabled, isChildRouteAdvertised } = useIsChildRouteEnabled();

    if (!props.mainRoute || !isRouteEnabled(props.mainRoute)) {
        return null;
    }

    return (
        <>
            <NavigationSubMenuItem to={props.mainRoute.path} testId={props.mainRoute.testId}>
                {t(props.mainRoute.title)}
            </NavigationSubMenuItem>

            {isChildRouteEnabled(KNOWLEDGE_BASE_ROUTE) && (
                <NavigationSubMenuItem
                    to={KNOWLEDGE_BASE_ROUTE.path}
                    isAdvertised={isChildRouteAdvertised(KNOWLEDGE_BASE_ROUTE)}
                    rightSection={<External size={20} color={"--app-subNavigationPanel-iconColor"} />}
                    testId={testIds.navigation.products.knowledgeBaseLink}
                >
                    {t(KNOWLEDGE_BASE_ROUTE.title)}
                </NavigationSubMenuItem>
            )}
        </>
    );
};
